<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ clientIcon }}</md-icon>
            </div>
            <add-button @add-click="addClient"></add-button>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="clients"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name">
                  <span v-if="item.stateId === 2"
                    ><badge type="warning"> Archived</badge>&nbsp;&nbsp;</span
                  ><router-link
                    v-if="item.stateId < 3"
                    :to="{
                      name: 'Client',
                      params: { clientId: item.id }
                    }"
                    >{{ item.name }}</router-link
                  >&nbsp;&nbsp;<span v-if="item.archiveMessage"
                    ><strong>Reason:</strong> {{ item.archiveMessage }}</span
                  >
                </md-table-cell>
                <md-table-cell class="text-right">
                  <edit-button
                    :isSmall="true"
                    :stateId="item.stateId"
                    @edit-click="editClient(item.id)"
                  ></edit-button
                  >&nbsp;
                  <state-button
                    tooltip="Archive Client"
                    type="Archive"
                    :role="4"
                    :managerOnly="true"
                    :stateId="item.stateId"
                    :canDelete="item.canDelete"
                    @state-click="archiveClient(item.id)"
                  ></state-button>
                  <state-button
                    tooltip="Delete Site"
                    type="Delete"
                    :role="4"
                    :managerOnly="true"
                    :stateId="item.stateId"
                    :canDelete="item.canDelete"
                    @state-click="deleteClient(item.id)"
                  ></state-button>
                  <state-button
                    type="Reactivate"
                    :role="4"
                    :stateId="item.stateId"
                    :canRestore="item.canRestore"
                    @state-click="reactivateClient(item.id)"
                  ></state-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state>No Clients Found</md-table-empty-state>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>library_books</md-icon>
            </div>
            <h4 class="title">Reports</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100">
                <md-button
                  class="md-primary"
                  @click="onGenerateActivePlantReport()"
                  >Active Plant for All Clients</md-button
                ><br />
                <md-button
                  class="md-primary"
                  @click="onGeneratePlantSummarytReport()"
                  >Plant Summary</md-button
                >
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import $ from "jquery";
import { mapGetters } from "vuex";
import { Badge } from "@/components";

export default {
  name: "ClientList",
  components: {
    Badge
  },
  computed: {
    ...mapGetters({
      clientIcon: "data-management-client/icon",
      clients: "data-management-client/clients"
    })
  },
  async created() {
    await this.getClientListing();
  },
  methods: {
    async getClientListing() {
      this.$store.dispatch("data-management-client/getClientListing");
    },
    editClient(id) {
      this.$router.push({
        name: "Edit Client",
        params: { clientId: id }
      });
    },
    addClient() {
      this.$router.push({ name: "Add Client" });
    },
    onGenerateActivePlantReport() {
      this.$store.dispatch("report/getActivePlantReport", {
        clientId: "0"
      });
    },
    onGeneratePlantSummarytReport() {
      this.$store.dispatch("report/getActivePlantSummaryReport");
    },
    archiveClient(clientId) {
      Swal.fire({
        title: "Archive client?",
        html: `<div class="md-field md-theme-default"><span>Message:&nbsp;</span><br/>
            <input type="text" id="md-input" class="md-input">
            </div>`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        confirmButtonText: "Yes, archive it!",
        cancelButtonClass: "md-button md-danger",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("data-management-client/archiveClient", {
              id: clientId,
              message: $("#md-input").val()
            })
            .then(() => {
              this.getClientListing();
            })
            .catch(error => {
              this.$notify({
                message: error.response.data.errors.Message[0],
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    },
    deleteClient(clientId) {
      Swal.fire({
        text: `Are you sure you want to delete this?`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("data-management-client/deleteClient", clientId)
            .then(() => {
              this.getClientListing();
            })
            .catch(error => {
              this.$notify({
                message: error.response.data,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    },
    reactivateClient(clientId) {
      this.$store
        .dispatch("data-management-client/reactivateClient", clientId)
        .then(() => {
          this.getClientListing();
        })
        .catch(error => {
          this.$notify({
            message: error.response.data,
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        });
    }
  }
};
</script>

<style></style>
